import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { FormButton } from '@/ui/Form';
import SimpleDialog from '@/ui/Dialog/SimpleDialog';
import DialogContext from '@/ui/DialogContext/DialogContext';
import { Typography } from '@mui/material';

const FormButtonApplyForExcursion = (props: { prijava: string }) => {
  const { t } = useTranslation();
  const dialogContext = useContext(DialogContext);

  const { prijava } = props;

  const handleApply = () => {
    console.log(dialogContext.showDialog);
    dialogContext.showDialog(
      SimpleDialog,
      {
        title: t('titles.prijava'),
        content: <Typography variant="body1" fontSize={"1.2rem"}>{prijava}</Typography>,
      },
      1
    );
  };

  return (
    <FormButton
      fullWidth={false}
      variant="contained"
      onClick={handleApply}
      sx={
        {
          /* this removes margin hardcoded into FormButton */
        }
      }
    >
      {t('buttons.apply_for_excursion')}
    </FormButton>
  );
};

export default FormButtonApplyForExcursion;
